import { getClientById, getThemeForClientId } from '../../../lib/getClientById';
import { THEMES, CLIENT_OVERRIDES, pickLink } from '../../../lib/themeConfig.js';

/**
 * @description Shared theme functionality mixin
 */
export default {
    data () {
        const clientId = this.getQueryStringValue
            ? (this.getQueryStringValue('client_id') || this.getQueryStringValue('clientId') || getClientById())
            : getClientById();
        const spEntityID = this.getQueryStringValue ? this.getQueryStringValue('spEntityID') || getClientById() : getClientById();
        const id = clientId || spEntityID;
        return {
            clientId: id,
            themeName: 'BASE',
            theme: THEMES.BASE,
            links: {
                terms: '',
                privacy: '',
                accessibility: '',
                contact: '',
                license: '',
                about: '',
                businessAssociate: '',
                modernSlavery: '',
                doNotSell: '',
                patentNotice: '',
                cookies: ''
            },
            ui: {
                showFooter: false,
                showBrandBadge: false,
                logoType: 'container',
                showPearsonLink: true,
                showNavRegion: false,
                copyrightYearInRange: false,
                copyrightText: {
                    companyName: 'Pearson',
                    allRightsReserved: ' All rights reserved.'
                }
            }
        };
    },
    created () {
        this.initTheme();
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
            // Re-initialize theme when locale changes to update footer links
            if (newLocale !== oldLocale) {
                this.initTheme();
            }
        }
    },
    methods: {
        initTheme () {
            const clientId = getClientById();
            this.themeName = getThemeForClientId(clientId);

            const baseTheme = THEMES[this.themeName] || THEMES.BASE;
            const overrides = CLIENT_OVERRIDES[clientId] || {};

            // Use overrides.links completely if present, otherwise use baseTheme.links
            const linksToUse = (overrides.links) ? overrides.links : baseTheme.links;

            const locale = (this.$i18n?.locale || navigator.language || 'en').toLowerCase();
            this.links = {
                about: pickLink(linksToUse.about, locale),
                license: pickLink(linksToUse.license, locale),
                terms: pickLink(linksToUse.terms, locale),
                termsofuse: pickLink(linksToUse.termsofuse, locale),
                privacy: pickLink(linksToUse.privacy, locale),
                businessAssociate: pickLink(linksToUse.businessAssociate, locale),
                contact: pickLink(linksToUse.contact, locale),
                accessibility: pickLink(linksToUse.accessibility, locale),
                modernSlavery: pickLink(linksToUse.modernSlavery, locale),
                doNotSell: pickLink(linksToUse.doNotSell, locale),
                patentNotice: pickLink(linksToUse.patentNotice, locale),
                cookieConsent: pickLink(linksToUse.cookieConsent, locale),
                permissions: pickLink(linksToUse.permissions, locale),
                support: pickLink(linksToUse.support, locale),
                cookies: pickLink(linksToUse.cookies, locale)
            };
            this.ui = { ...baseTheme.ui, ...(overrides.ui || {}) };
        },
        getQueryStringValue (name) {
            let url = decodeURIComponent(window.location.href);
            name = name.replace(/[[]/, '\\["').replace(/[\]]/, '\\]');
            let regexS = '[\\?&]' + name + '=([^&#]*)';
            let regex = new RegExp(regexS);
            let results = regex.exec(url);
            return results == null ? null : results[1];
        },
        pearsonLogoUrl () {
            var realm;
            if (this.$route.query.realm === undefined && localStorage.realm === undefined) {
                localStorage.realm = 'PEARSON';
                realm = 'PEARSON';
            } else if (this.$route.query.realm !== undefined) {
                localStorage.realm = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
                realm = this.$route.query.realm.replace('/', '').replace('%2f', '').replace('%2F', '').toUpperCase();
            } else if (localStorage.realm !== undefined) {
                realm = localStorage.realm;
            }
            if (realm === 'PEARSONCOLLEGELONDON') {
                return require('@/assets/images/pcl_white.png');
            } else {
                return require('@/assets/images/PearsonLogo_Horizontal_Blk_RGB.png');
            }
        }
    }
};
